import loadable from "@react-loadable/revised";
import Loading from "../components/Loading";
import AuthProvider from "../components/AuthProvider";
import { getPromotionPageName } from "../helper/GlobalValueHelper";
import DashboardLayout from "../components/DashboardLayout";

const List = loadable({
  loader: () => import("../views/promotion/List"),
  loading: Loading,
});
const Edit = loadable({
  loader: () => import("../views/promotion/Edit"),
  loading: Loading,
});
const Create = loadable({
  loader: () => import("../views/promotion/Create"),
  loading: Loading,
});

const PromotionRoute = {
  element: <DashboardLayout />,
  children: [
    {
      path: "/promotions",
      element: (
        <AuthProvider page={getPromotionPageName()} action={"view"}>
          <List />
        </AuthProvider>
      ),
    },
    {
      path: "/promotions/:id",
      element: (
        <AuthProvider page={getPromotionPageName()} action={"view"}>
          <Edit />
        </AuthProvider>
      ),
    },
    {
      path: "/promotions/create",
      element: (
        <AuthProvider page={getPromotionPageName()} action={"create"}>
          <Create />
        </AuthProvider>
      ),
    },
  ],
};

export default PromotionRoute;
